/* eslint-disable react/no-danger */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Reset,
  Theme,
  GridContainer,
  Snackbar,
  Text,
} from '@resultadosdigitais/tangram-components';

import AlertActions from './AlertActions';

function AlertApp({ alerts, onClose }) {
  if (alerts.length === 0) {
    return null;
  }

  return (
    <Theme value={Theme.kinds.lina}>
      <Reset />
      <GridContainer>
        {alerts.map(
          ({
            alertKey,
            kind,
            size,
            title,
            message,
            dangerouslyMessageHTML,
            actions,
            hideIcon,
          }) => {
            const formattedMsg = dangerouslyMessageHTML ? (
              <span dangerouslySetInnerHTML={{ __html: message }} />
            ) : (
              message
            );

            const textStyle = { marginTop: title ? 12 : 0 };
            if (!actions) {
              textStyle.marginBottom = 0;
            }

            return (
              <Snackbar
                key={alertKey}
                style={{
                  display: 'flex',
                  marginBottom: 'var(--size-spacing-04)',
                }}
                kind={kind || Snackbar.kinds.default}
                title={title}
                message={formattedMsg}
                onClose={() => {
                  onClose(alertKey);
                }}
                action={<AlertActions alertKey={alertKey} actions={actions} />}
                size={size}
              >
                {!hideIcon && <Snackbar.Icon kindMessage={kind} />}
                <Snackbar.Content>
                  {title && <Snackbar.Title>{title}</Snackbar.Title>}
                  <Text style={textStyle}>{formattedMsg}</Text>
                  <AlertActions actions={actions} />
                </Snackbar.Content>
              </Snackbar>
            );
          }
        )}
      </GridContainer>
    </Theme>
  );
}

AlertApp.defaultProps = {
  alerts: [],
  onClose: undefined,
};

AlertApp.propTypes = {
  alerts: PropTypes.arrayOf(
    PropTypes.shape({
      alertKey: PropTypes.string,
      kind: PropTypes.string,
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      actions: PropTypes.array,
    })
  ),
  onClose: PropTypes.func,
};

export default AlertApp;
